/* eslint-disable */
function hexToRgb(hex) {
  hex = hex.replace(/^#/, "");
  if (hex.length === 3) {
    hex = hex.split("").map(h => h + h).join("");
  }
  const num = parseInt(hex, 16);
  return [num >> 16 & 255, num >> 8 & 255, num & 255];
}

function luminance([r, g, b]) {
  const a = [r, g, b].map(v => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

function contrastRatio(color1, color2) {
  const lum1 = luminance(hexToRgb(color1));
  const lum2 = luminance(hexToRgb(color2));
  const lighter = Math.max(lum1, lum2);
  const darker = Math.min(lum1, lum2);
  return (lighter + 0.05) / (darker + 0.05);
}

function ensureContrast(bgHex, fgHex) {
  if (contrastRatio(bgHex, fgHex) >= 4.5) {
    return fgHex; // Already good contrast
  }
  // Adjust to either black or white
  return contrastRatio(bgHex, "#000000") > contrastRatio(bgHex, "#FFFFFF") ? "#000000" : "#FFFFFF";
}

function rgbToHex([r, g, b]) {
  return `#${(1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1).toUpperCase()}`;
}

function isContrastSufficient(bgHex, colorHex, targetRatio = 4.5) {
  if (bgHex.includes("rgb")){
    const extractedRgbValues = bgHex.replace("rgb(", "").replace(")", "").split(",").map(v => parseInt(v));
    bgHex = rgbToHex(extractedRgbValues);
  }
  if (colorHex.includes("rgb")){
    const extractedRgbValues = colorHex.replace("rgb(", "").replace(")", "").split(",").map(v => parseInt(v));
    colorHex = rgbToHex(extractedRgbValues);
  }
  return contrastRatio(bgHex, colorHex) >= targetRatio;
}

export { ensureContrast, rgbToHex, isContrastSufficient, contrastRatio };
